import React from 'react';

export default class LiveErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('[LiveErrorBoundary]', error);
  }

  handleRetry = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const title = this.props.title || 'Trading screen';

    return (
      <div style={{ padding: 24, minHeight: '50vh', color: 'var(--app-text, #e2e8f0)' }}>
        <div style={{
          maxWidth: 560,
          margin: '40px auto',
          padding: 20,
          borderRadius: 12,
          border: '1px solid #334155',
          background: 'var(--app-bg-card, #1a2332)'
        }}
        >
          <h1 style={{ marginTop: 0, fontSize: '1.2rem' }}>{title}</h1>
          <p style={{ color: '#94a3b8' }}>UI hit an error — backend bot can still be running.</p>
          <p style={{ color: '#f87171', fontSize: '0.9rem', wordBreak: 'break-word' }}>
            {error.message || 'Unknown error'}
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            style={{
              marginTop: 12,
              minHeight: 44,
              padding: '10px 16px',
              borderRadius: 8,
              border: 'none',
              background: '#3b82f6',
              color: '#fff',
              fontWeight: 700
            }}
          >
            Reload screen
          </button>
        </div>
      </div>
    );
  }
}
